import { Link } from 'react-router-dom'
import { StoreImage } from '@/store/components/StoreImage'
import { cn } from '@/lib/utils'

const noteTileClass =
  'group flex w-[168px] shrink-0 flex-col items-center gap-3 sm:w-[172px] md:w-[188px] focus-ring rounded-xl'

const noteImageSize =
  'h-[160px] w-[160px] sm:h-[164px] sm:w-[164px] md:h-[180px] md:w-[180px]'

const noteLabelClass =
  'w-full text-center text-xs font-semibold leading-tight gold-gradient-text sm:text-sm'

function noteFrameClass(variant: 'a' | 'b') {
  return variant === 'a' ? 'brand-radius-a' : 'brand-radius-b'
}

function noteInitial(name: string) {
  return name.trim().charAt(0).toUpperCase() || '?'
}

interface FragranceNoteChipProps {
  noteId: string
  name: string
  image?: string
  variant?: 'a' | 'b'
  className?: string
}

export function FragranceNoteChip({
  noteId,
  name,
  image,
  variant = 'a',
  className,
}: FragranceNoteChipProps) {
  const frameClass = noteFrameClass(variant)

  return (
    <Link
      to={`/shop?note=${encodeURIComponent(noteId)}`}
      className={cn(noteTileClass, className)}
    >
      <div
        className={cn(
          'gold-gradient-ring p-[2.5px] shadow-md shadow-gold-500/20',
          'transition-transform duration-300 group-hover:scale-105',
          noteImageSize,
          frameClass
        )}
      >
        <div
          className={cn(
            'h-full w-full overflow-hidden bg-[#FAF8F4] ring-2 ring-white',
            frameClass
          )}
        >
          {image ? (
            <StoreImage
              src={image}
              alt=""
              className="h-full w-full object-cover"
            />
          ) : (
            <div
              className="flex h-full w-full items-center justify-center bg-gradient-to-br from-white via-gold-50/70 to-[#FAF8F4] text-2xl font-semibold text-gold-700 sm:text-3xl"
              aria-hidden
            >
              {noteInitial(name)}
            </div>
          )}
        </div>
      </div>
      <span className={cn(noteLabelClass, 'line-clamp-2')}>{name}</span>
    </Link>
  )
}
